import ApiService from './api.service'
import { TokenService } from './storage.service'


class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const UserService = {
    /**
     * Login the user and store the access token to TokenService. 
     * 
     * @returns access_token
     * @throws AuthenticationError 
    **/
    login: async function (email, password) {
        const requestData = {
            method: 'post',
            url: "/users/authenticate/",
            data: {
                //grant_type: 'password',
                email: email,
                password: password
            },auth: {
                username: process.env.VUE_APP_CLIENT_ID,
                password: process.env.VUE_APP_CLIENT_SECRET
            }
        }

        try {
            const response = await ApiService.customRequest(requestData)

            TokenService.saveToken(response.data.access_token)
            TokenService.saveRefreshToken(response.data.refresh_token)
            ApiService.setHeader()

            // NOTE: We haven't covered this yet in our ApiService 
            //       but don't worry about this just yet - I'll come back to it later
            ApiService.mount401Interceptor();

            return response.data.access_token
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Refresh the access token.
    **/
    refreshToken: async function (email, password) {
        console.log("entra metodo refresh");
        const refreshToken = TokenService.getRefreshToken()

        const requestData = {
            method: 'post',
            url: "/users/token",
            data: {
                grant_type: 'refresh_token',
                refresh_token: refreshToken
            }/*,
            auth: {
                username: process.env.VUE_APP_CLIENT_ID,
                password: process.env.VUE_APP_CLIENT_SECRET
            }*/
        }

        try {
            const response = await ApiService.customRequest(requestData)
            console.log(response);

            TokenService.saveToken(response.data.access_token)
            TokenService.saveRefreshToken(response.data.refresh_token)
            // Update the header in ApiService
            ApiService.setHeader()

            return response.data.access_token
        } catch (error) {
            console.log(error); //entra aqui
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }

    },

    /**
     * Logout the current user by removing the token from storage. 
     * 
     * Will also remove `Authorization Bearer <token>` header from future requests.
    **/
    logout() {
        // Remove the token and remove Authorization header from Api Service as well 
        TokenService.removeToken()
        TokenService.removeRefreshToken()
        ApiService.removeHeader()

        // NOTE: Again, we'll cover the 401 Interceptor a bit later. 
        ApiService.unmount401Interceptor()
    },

    /**
     * Register new user 
     */
    SingIn(data) {
        return ApiService.post('users',data);
    },

    edit: async function(data) {
        try {
            const response = await ApiService.put('users/',data);
            console.log(response);
            ApiService.mount401Interceptor();
            return response.data.success;
        }catch (error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }
    },

    /**
     * Obtener un usuario por su ID
     */
    getUserOne(userId){
        return ApiService.get(`users/${userId}/`);
    }
}

export default UserService

export { UserService, AuthenticationError }